import { Component } from '@angular/core';
import { FeedbackPlatformPresentationCategoryEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Presentation Categories') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-feedbackplatformpresentationcategory-form',
    templateUrl: './feedbackplatformpresentationcategory.form.component.html'
})
export class FeedbackPlatformPresentationCategoryFormComponent extends BaseFormComponent {
    public record!: FeedbackPlatformPresentationCategoryEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'reviewQuestions', sectionName: 'Review Questions', isExpanded: false },
            { sectionKey: 'presentations', sectionName: 'Presentations', isExpanded: false }
        ]);
    }
}

